import { Components, Theme } from '@mui/material';
import { darkColors } from './colors';

/**
 * Creates MUI component overrides for dark mode
 * @param primaryColor - The primary color for focused states
 */
export function createDarkModeOverrides(primaryColor: string): Components<Theme> {
  return {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: darkColors.background.paper,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: darkColors.background.paper,
          borderColor: darkColors.divider,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: darkColors.background.paper,
          backgroundImage: 'none',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: darkColors.background.paper,
          backgroundImage: 'none',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundColor: darkColors.background.paper,
          backgroundImage: 'none',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          backgroundColor: darkColors.background.paper,
        },
        listbox: {
          backgroundColor: darkColors.background.paper,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: darkColors.divider,
        },
        head: {
          fontWeight: 600,
          backgroundColor: darkColors.background.paper,
          color: darkColors.text.primary,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: darkColors.border,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: darkColors.borderHover,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: primaryColor,
          },
        },
        input: {
          '&::placeholder': {
            color: darkColors.borderHover,
            opacity: 1,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: darkColors.text.secondary,
          '&.Mui-focused': {
            color: primaryColor,
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: darkColors.borderHover,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: darkColors.text.secondary,
          '&.Mui-selected': {
            color: primaryColor,
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: primaryColor,
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          backgroundColor: darkColors.border,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        outlinedSuccess: {
          backgroundColor: '#1E293B',
          color: '#F1F5F9',
          borderColor: '#34D399',
          '& .MuiAlert-icon': {
            color: '#34D399',
          },
        },
        outlinedInfo: {
          backgroundColor: '#1E293B',
          color: '#F1F5F9',
          borderColor: '#38BDF8',
          '& .MuiAlert-icon': {
            color: '#38BDF8',
          },
        },
        filledWarning: {
          color: '#FFFFFF',
          '& .MuiAlert-icon': {
            color: '#FFFFFF',
          },
        },
        filledError: {
          color: '#FFFFFF',
          '& .MuiAlert-icon': {
            color: '#FFFFFF',
          },
        },
      },
    },
  };
}
